import React, { ComponentProps } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import ILink from '../../types/ILink';
import { Icons, SVG } from '../../components/atoms/SVG';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import Hyperlink from '../../components/atoms/Hyperlink/Hyperlink';
import { useSonTranslation } from '../../translation/useSonTranslation';

type BackToParentProps = {
  parentLink: ILink;
  parentPageType: 'forum';
};

function BackToParent({ parentLink, parentPageType }: BackToParentProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  const { t } = useSonTranslation('BackToParent');

  if (active) {
    return null;
  }

  /**
   * This renders the link back to the parent page on organisational units
   */
  return (
    <div className="back-to-parent">
      <Hyperlink to={parentLink.url} className="back-to-parent__link">
        <SVG svgSpriteId={Icons.PAGE_BACK} svgClass="back-to-parent__icon" />
        {t(`type.${parentPageType}`, { name: parentLink.name })}
      </Hyperlink>
    </div>
  );
}

export const BackToParentBlock = asFetchableBlock(BackToParent, BlockType.backtoparent);
export type BackToParentBlock = ComponentProps<typeof BackToParentBlock>;
